// extracted by mini-css-extract-plugin
module.exports = {"venueSpinner":"Spinner_venueSpinner__xKOiv"};